import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { tokens } from "../../../theme";

// import { getOrderStatusCounts } from "../../../api/orders/orders";
import { useTranslation } from 'react-i18next';
import OutboundActionRequiredView from "./views/ActionRequired";
import OutboundOrdersView from "./views/Orders";
import OutboundShippedView from "./views/Shipped";
import OutboundCancelledView from "./views/Cancelled";
import OutboundBackorderView from "./views/Backorder";
import OutboundOrderlines from "./views/Orderlines";
import OutboundSnoozedView from "./views/Snoozed"
import OutboundShipments from "./views/Shipments"
import OutboundAllView from "./views/All"

import { useGetOrderTotalsQuery } from "../../../newapi/order/ordersSlice";
import { defaultPollingInterval } from "../../../utils/constants";

import TabView3 from "../../../components/theme/TabView3/TabView3";
import OrderRevenueTotalsPanel from "../../../components/global/dashboard/OrderRevenueTotalsPanel";
import { relationOrdersConfig } from "./relationOrdersConfig";
import OutboundBolView from "./views/Bol";
import OutboundAmazonFbaView from "./views/AmazonFba";
import { useTopbar } from "../../../contexts/TopbarProvider";
import OutboundOrderLogsView from "./views/OrderLogs";
import { useSelector } from "react-redux";
import { selectUserPermission } from "../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../utils/permissions";
const RelationOutbound = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const hasFinancialPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_INVOICE_READ])
    );
    const hasAmazonManagePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.AMAZON_MANAGE])
    );

    const { data : orderTotals, isLoading: totalIsLoading } = useGetOrderTotalsQuery("state", { pollingInterval: defaultPollingInterval });
    const [config, setConfig] = useState(relationOrdersConfig(orderTotals, hasAmazonManagePermission));
    useEffect(() => {
        setConfig(relationOrdersConfig(orderTotals, hasAmazonManagePermission));
    }, [orderTotals, hasAmazonManagePermission]);

    const { showExtraTitle,clearExtraTitle } = useTopbar();

    useEffect(() => {
        showExtraTitle(t("orders"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {hasFinancialPermission && (
            <OrderRevenueTotalsPanel/>
            )}

            <TabView3
                tabConfig={config}
                sx={{
                    width:1,
                    background:"green",
                    minHeight:"calc(100% - 431px)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,

                    display:"flex",
                    flexDirection:"column",

                    "&:before" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        left:0,
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition:"250ms"
                    },

                    "&:after" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        right:0,
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform:"scaleX(-1)",
                        transition:"250ms"
                    },

                    "@media screen and (max-width: 47.9375em)" : {
                        "&:after, &:before" : {
                            top:"-0px"
                        }
                    }
                }}
                title={t("outbound")}
                
            >
                <>
                    <OutboundOrdersView config={config.orders}/>
                    <OutboundActionRequiredView config={config.ordersActionRequired} />
                    <OutboundShippedView config={config.ordersShipped}/>
                    <OutboundBackorderView config={config.ordersBackordered}/>
                    <OutboundSnoozedView config={config.orderSnoozed}/>
                    <OutboundCancelledView config={config.ordersCancelled}/>
                    <OutboundAllView config={config.ordersAll}/>
                    <OutboundBolView config={config.ordersBol}/>
                    {hasAmazonManagePermission && (<OutboundAmazonFbaView config={config.ordersAmazonFba}/>)}
                    <OutboundOrderLogsView config={config.orderlogs}/>
                    <OutboundOrderlines config={config.orderlines}/>
                </>
            </TabView3>
        </Box>
    );
};

export default RelationOutbound;